// Hideo - a new video in the plan, as the quick ways of adding one write it (an idea from the Home, a keyword, a file
// dropped on the Board, Calendar or Timeline): the fields always in this order, so the saved JSON stays the same; the
// first type of the profile, Medium priority, status Idea unless given. `extra` fields go at the end (seo, workStart).
import type { ProfileData, StatusKey, Video } from './types'

interface NewVideo {
  id: string
  title: string
  projectId: string
  status?: StatusKey | string
  publishDate?: string
  publishTime?: string
  thumbnail?: string
  voiceNote?: string
}

export function newVideo(d: Pick<ProfileData, 'settings'>, o: NewVideo, extra: Partial<Video> = {}): Video {
  return {
    id: o.id, title: o.title, projectId: o.projectId, link: '', scriptId: '', status: o.status || 'Idea', format: d.settings.formats[0], priority: 'Media',
    reelProva: 'No', publishDate: o.publishDate || '', publishTime: o.publishTime || '', thumbnail: o.thumbnail || '', voiceNote: o.voiceNote || '',
    checklist: {}, notes: '', ...extra
  } as Video
}
